import React from 'react';
export const DOOR_PALETTE = ['#be123c', '#047857', '#b45309', '#0e7490', '#be185d', '#d97706' // Amarillo/Ámbar
];
export const WOOD_TEXTURE_CSS = `repeating-linear-gradient(
  90deg,
  transparent,
  transparent 4px,
  rgba(0,0,0,0.04) 4px,
  rgba(0,0,0,0.04) 8px
)`;
export function DoorStrip({
  inverted = false,
  height = 'h-5'
}: {
  inverted?: boolean;
  height?: string;
}) {
  const colors = inverted ? [...DOOR_PALETTE].reverse() : DOOR_PALETTE;
  return <div className={`flex w-full ${height}`} data-id="element-115">
      {colors.map((color, i) => <div key={i} className="flex-1 h-full relative border-r border-black/5 last:border-r-0" style={{
      backgroundColor: color,
      backgroundImage: WOOD_TEXTURE_CSS
    }} data-id="element-116">
          <div className="absolute inset-0 shadow-[inset_0_2px_4px_rgba(0,0,0,0.12)] pointer-events-none" data-id="element-117" />
        </div>)}
    </div>;
}